namespace GeniuzPOS.Inventory {
    export class IcStockReturnInColumns {
        static columnsKey = 'Inventory.IcStockReturnIn';
    }
}
